import { executeRequest, Request } from '@jfs/network'
import { errorMessage } from '../../utils/string'
import { getAPIURL, getPaymentHeader } from '../config'

const responseParser = (data: any) => {
  if (data?.httpCode === 200 && data?.status?.status === 'SUCCESS') {
    return data.status
  } else {
    return {
      status: 'FAILED',
      error: { message: data?.status?.failureMessage ?? errorMessage.defautCatchMessage },
    }
  }
}
/**
 * New PG
 * It Will delete the card
 * @param deleteCardBody
 * @param token
 */
const deleteCard = (deleteCardBody: any, token: string) => {
  const request: Request<{}> = {
    apiPath: `${getAPIURL('addDeleteCard')}/${token}`,
    method: 'POST',
    headers: getPaymentHeader(),
    body: deleteCardBody,
  }
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .catch((err) => {
      const {
        data: { error },
      } = err
      throw error
    })
}

export { deleteCard }
